module.exports = __webpack_public_path__ + "static/media/cockpit_icon2.92d00e41.svg";